import { combineReducers } from 'redux'
import vehiclesUiReducer from '../Vehicles/Redux/Ui'

export default combineReducers({
  vehicles: vehiclesUiReducer,
})
